<script>
import { useAuthStore } from '@/stores/auth';
import { useTranslationStore } from '../stores/translation';
import { storeToRefs } from 'pinia';
import { ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ZH_PATHS, zhPath, enPath } from '@/router';
import { useWeeklyMenuStore } from '@/stores/weeklyMenu';

export default {
  name: 'NavbarMenu',
  setup() {
    const authStore = useAuthStore();
    const { user } = storeToRefs(authStore);

    const toggleSidebar = ref(null);

    const closeOffcanvas = () => {
        try {
            const offcanvasElement = document.getElementById('mobilemenu');
            if(offcanvasElement && offcanvasElement.classList && offcanvasElement.classList.contains('show')){
                if (toggleSidebar.value && toggleSidebar.value.click) {
                    toggleSidebar.value.click();
                }
            }
        } catch (error) {
            console.error('Error in closeOffcanvas:', error);
        }
    };

    const translationStore = useTranslationStore();
    const selectedLanguage = ref(translationStore.currentLanguage);
    const route = useRoute(); const router = useRouter();

    const changeLanguage = () => {
      translationStore.setLanguage(selectedLanguage.value);
      // Public pages have a Chinese address (/zh/…): switch the URL too so the page a
      // visitor shares or Google indexes matches the language they're reading.
      try {
        const cur = route.path;
        const isZh = cur === '/zh' || cur.startsWith('/zh/');
        if (selectedLanguage.value === 'zh' && !isZh && ZH_PATHS.some((p) => matchesPublic(p, cur))) router.push(zhPath(cur));
        else if (selectedLanguage.value !== 'zh' && isZh) router.push(enPath(cur));
      } catch (e) { /* noop */ }
    };
    const matchesPublic = (pattern, path) => (pattern.includes(':') ? path.startsWith(pattern.split(':')[0]) : pattern === path);

    const t = (label, modules) => {
      return translationStore.translate(label, modules);
    };

    // Weekly-menu switch: when the owner turns it on, the same two nav labels lead to
    // the date-first menu and the package builder instead of the legacy pages.
    watch(() => translationStore.currentLanguage, (v) => { selectedLanguage.value = v; });
    const weekly = useWeeklyMenuStore();
    if (!weekly.config && !weekly.loadingConfig) weekly.loadConfig(translationStore.currentLanguage).catch(() => {});
    const weeklyOn = computed(() => weekly.enabled);

    return {
      user,
      weeklyOn,
      closeOffcanvas,
      toggleSidebar,
      selectedLanguage,
      changeLanguage,
      t,
    };
  },
};
</script>


<template>
    <button type="button" ref="toggleSidebar" class="d-none" data-bs-toggle="offcanvas" data-bs-target="#mobilemenu"></button>
    <div class="navbar-collapse" id="navbarSupportedContent">
        <div class="d-flex idendity-logo hidden-collapse align-items-start justify-content-between">
            <a class="navbar-brand w-15 p-0 m-0" href="#">
                <img src="@/assets/logo-wordmark-green.png" alt="CHDS 吃荤搭素" style="max-width: 150px; height: auto;">
            </a>
            <div class="cross-icon">
                <i class="fa-solid fa-xmark"></i>
            </div>

        </div>
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
            <router-link class="nav-link" to="/" active-class="active"  @click="closeOffcanvas" >{{ t('home', ['navbar']) }}</router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="weeklyOn ? '/menu' : '/ordernow'" active-class="active"  @click="closeOffcanvas" >{{ t('order_now', ['navbar']) }}</router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="weeklyOn ? '/packages' : '/box'" active-class="active"  @click="closeOffcanvas" >{{ t('nav_label', ['box']) }}</router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/ourstory" active-class="active"  @click="closeOffcanvas">{{ t('Our_story', ['navbar']) }}</router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" to="/contact-us" active-class="active" @click="closeOffcanvas">{{ t('contact', ['navbar']) }}</router-link>
        </li>


       
        <div class="login-register d-flex align-items-center gap-3 show-login" v-if="!user">
            <!-- <div class="icon-location">
                <i class="fa-solid fa-user"></i>
            </div> -->
            <a class="mb-0 nav-link" type="button" data-bs-toggle="modal" data-bs-target="#registerModal" data-bs-dismiss="offcanvas" > Register
            </a>

            <a class="mb-0 nav-link" type="button" data-bs-toggle="modal" data-bs-target="#loginModal" data-bs-dismiss="offcanvas" > Login
            </a>
        </div>
        </ul>
        
        <div class="d-flex gap-2 contact-wrap">
            <form class="d-flex position-relative border-set" role="search">
                <select class="form-select search" aria-label="Default select example"  v-model="selectedLanguage" @change="changeLanguage">
                    <option value="en">English</option>
                    <option value="zh">中文</option>
                </select>
            </form>
        </div>
    </div>
    
</template>

<style>

@media screen and (max-width:991.91px) {
    .idendity-logo{
        display: none !important;
        padding: 0;
    }

    .navbar-collapse.idendity-logo{
        padding: 0;
    }

    .contact-wrap{
        padding: 2rem 0;
    }

}

 

</style>